export default __webpack_public_path__ + "static/media/rent-second-img1.526ec043.jpg";